// import LogoRed from "./appLogoRed.png";
import LogoWhite from "./logo.png";
import logoRed from "./logo-red.png";
// import LogoBlack from "./appLogoWhatsBanned.png";
import emptyImage from "./emptyImage.png";
import sperrinLogo from "./pdfWaterMark-old.png";

// import svg from "../../Assets/svg";

export const allCommonImages = {
  LogoWhite,
  // LogoBlack,
  emptyImage,
  logoRed,
  sperrinLogo,
  // LogoRed: LogoRed,

  // LogoBlack: svg.appLogo,
  // LogoWhite: svg.appLog,
};
